import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  height: 620px; /** Modal size - content size **/
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ErrorWrapper = styled.div`
  height: 292px;
`;
